<div class="plan-card">
  <button
    class="plan-toggle-button"
    (click)="toggleExpanded()"
    [attr.aria-expanded]="isExpanded()"
    aria-label="Expandir o contraer detalles del plan"
    type="button"
  >
    <h2 class="plan-card__title">Resumen de tu compra</h2>
    <svg
      class="toggle-arrow"
      [class.expanded]="isExpanded()"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  </button>

  <div class="plan-card__header-content">
    <div class="plan-card__image">
      <img *ngIf="imageSrc(); else defaultIcon" [src]="imageSrc()" alt="Resumen de tu compra" />
      <ng-template #defaultIcon>
        <!-- Ícono de casa SVG inline (evita dependencia de asset) -->
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            d="M50 15 L15 45 L15 85 L40 85 L40 60 L60 60 L60 85 L85 85 L85 45 Z"
            fill="#dfeaff"
            stroke="#0033a0"
            stroke-width="3"
            stroke-linejoin="round"
          />
          <rect x="65" y="20" width="10" height="18" fill="#0033a0" />
        </svg>
      </ng-template>
    </div>

    <div class="owner-section">
      <p class="owner-section__text"><strong>Dirección:</strong> {{ propertyAddress() || 'No disponible' }}</p>
      <ng-container *ngIf="owner() as ownerData">
        <p *ngIf="ownerData.fullname" class="owner-section__text">
          <strong>Propietario:</strong> {{ ownerData.fullname }}
        </p>
        <p *ngIf="ownerData.document?.number" class="owner-section__text">
          <strong>Documento:</strong> {{ getDocumentType(ownerData.document.type) }} {{ ownerData.document.masked || ownerData.document.number }}
        </p>
      </ng-container>
      <p *ngIf="city()" class="owner-section__text"><strong>Ciudad:</strong> {{ city() }}</p>
    </div>
  </div>

  <ng-container *ngIf="isExpanded()">
    <hr class="plan-divider" />
    <div class="plan-selected-info">
      <h2 class="plan-card__title m-0">Plan elegido</h2>
      <div class="plan-details">
        <div class="plan-info-row">
          <span class="plan-info-row__label">{{ planTitle() }}</span>
          <span *ngIf="planTitle() === 'Plan Premium'" class="plan-info-row__badgeArmaPlan">Más coberturas</span>
          <span *ngIf="planTitle() === 'Plan Esencial'" class="plan-info-row__badgePlanEsencial">Más económico</span>
          <span *ngIf="planTitle() === 'Plan Total'" class="plan-info-row__badgePlanPlus">Más elegido</span>
        </div>

        <div class="plan-info-row">
          <span class="plan-info-row__label">Forma de pago</span>
          <span class="plan-info-row__value text-bold">{{ paymentType() }}</span>
        </div>

        <div class="plan-info-row">
          <span class="plan-info-row__label-main">Valor total del seguro</span>
          <span class="plan-info-row__price">${{ formatPrice(totalAmount()) }}</span>
        </div>

        <div *ngIf="paymentType() === 'Mensual'" class="plan-info-row">
          <span class="plan-info-row__label">Valor pago mensual</span>
          <span class="plan-info-row__value text-bold">${{ formatPrice(monthlyAmount()) }}</span>
        </div>
      </div>

      <div class="coverages-section" *ngIf="coverages()?.length">
        <h3 class="coverages-section__title">Estas son las coberturas de tu plan:</h3>
        <ul class="coverages-list">
          <ng-container *ngFor="let coverage of coverages()">
            <li *ngIf="coverage.include !== false" class="coverage-item">
              <span class="coverage-item__text">{{ coverage.name }}</span>
            </li>
          </ng-container>
        </ul>
      </div>

      <br />
      <hr class="plan-divider" />

      <div class="payment-summary">
        <ng-container *ngIf="paymentType() === 'Mensual'; else annualBlock">
          <div class="payment-summary__content">
            <h2 class="payment-summary__title">Hoy pagas</h2>
            <span class="payment-summary__subtitle d-block d-md-none"
              >Corresponde a tu primer mes <br />
              IVA incluido</span
            >
            <span class="payment-summary__subtitle d-none d-md-block">Corresponde a tu primer mes - IVA incluido</span>
          </div>
          <div class="payment-summary__amount">${{ monthlyAmount() | number: '1.0-0' }}</div>
        </ng-container>
        <ng-template #annualBlock>
          <div class="payment-summary__content">
            <h2 class="payment-summary__title">Hoy pagas</h2>
            <span class="payment-summary__subtitle">IVA incluido</span>
          </div>
          <div class="payment-summary__amount">${{ totalAmount() | number: '1.0-0' }}</div>
        </ng-template>
      </div>
    </div>
  </ng-container>
</div>
